// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TtbJ+","banButton":"styles_banButton__WMn7J","formContainer":"styles_formContainer__+4mxs"};